<div class="viewport viewport-full viewport-center bg-secondary">
  <div class="content">
    <h1>{{ 'WELCOME.title' | translate }}</h1>
    <h2>{{ 'WELCOME.subtitle' | translate }}</h2>
    <button kendoButton themeColor="light" size="large" (click)="start()">{{ 'WELCOME.startNow' | translate }}</button>
  </div>
  <div class="logo-wrapper">
    <img ngSrc="/images/logo_w_text_white.png" alt="Famulus Logo with text" priority fill>
  </div>
</div>
